import { lazy } from '@/service/lazy'

export default [{
  name: 'Expirado',
  path: 'expirado',
  component: lazy('app/auth/login/index')
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/expirado.js